import { getOfficialStandardText } from "../../data/defensieStandards";

const mariniersConfig = {
  meta: {
    title: "Voorbereiding Korps Mariniers | Mission Movement",
    description:
      "Alles over voorbereiding richting het Korps Mariniers: selectie, opleiding, fysieke eisen, mentale weerbaarheid, belastbaarheid en gerichte training via Mission Movement.",
    ogTitle: "Voorbereiding Korps Mariniers | Mission Movement",
    ogDescription:
      "Alles over voorbereiding richting het Korps Mariniers: selectie, opleiding, fysieke eisen, mentale weerbaarheid, belastbaarheid en gerichte training via Mission Movement.",
    ogImage: "https://missionmovement.nl/img/thestory.png",
    ogUrl: "https://missionmovement.nl/units/mariniers",
    canonical: "https://missionmovement.nl/units/mariniers",
  },
  hero: {
    eyebrow: "Mariniers",
    imageSrc: "/img/spelioladder.jpg",
    imageAlt: "Spelioladder Mariniers",
    objectPosition: "bottom",
    overlayClass: "mm-heroOverlay",
    title: "Korps Mariniers",
    subtitle:
      "Voor kandidaten die serieus richting het Korps Mariniers willen werken: van selectie en keuring tot opleiding, belastbaarheid en voorbereiding.",
  },
  subNav: {
    variant: "dark",
    scrollable: false,
  },
  intro: {
    emblemSrc: "/img/eenheden/kmarns_embleem.svg",
    emblemAlt: "Korps Mariniers Embleem",
    heading: "Wat is het Korps Mariniers?",
    body:
      "Het Korps Mariniers is de amfibische infanterie van de Koninklijke Marine. Ze zijn gespecialiseerd in operaties vanuit zee naar land, maar ook inzetbaar in de lucht en op het land. Mariniers opereren wereldwijd in de zwaarste omstandigheden, van poolgebieden tot tropische regenwouden, in conflictgebieden of bij humanitaire rampen.\n\nDeze eenheid staat bekend om discipline, fysieke kracht, mentale weerbaarheid en sterke onderlinge verbondenheid. Of je nu kiest voor de rol van manschap of officier: je betreedt een omgeving waarin alleen de meest gedreven en goed voorbereide kandidaten kunnen slagen.\n\nVoor kandidaten betekent dit dat voorbereiding verder moet gaan dan alleen fit worden voor een testmoment. Je moet bouwen aan kracht, conditie, zwemvaardigheid, herstel, discipline en mentale weerbaarheid. Niet alleen om door de keuring te komen, maar om sterker te starten aan de opleiding.",
    accentBorder: "border-mmAccent",
  },
  accordion: {
    heading: null,
    items: [
      {
        title: "Ontstaan & Missie",
        image: "/img/korpsmariniers/chatham.jpg",
        objectPosition: "bottom",
        content:
          "Het Korps Mariniers werd opgericht op 10 december 1665 tijdens de Tweede Engels-Nederlandse Oorlog, op initiatief van raadpensionaris Johan de Witt en admiraal Michiel de Ruyter. Het doel was het creëren van een gespecialiseerde eenheid voor amfibische oorlogsvoering, die zowel op zee als op land effectief kon opereren. Sindsdien heeft het korps deelgenomen aan talloze militaire operaties wereldwijd, variërend van de Slag bij Chatham in 1667 tot recente missies in Afghanistan en Mali. Het motto van het korps, 'Qua Patet Orbis' ('Zo wijd de wereld strekt'), weerspiegelt de wereldwijde inzetbaarheid en het streven naar operationele excellentie onder alle omstandigheden.",
      },
      {
        title: "Inzet & Specialisaties",
        image: "/img/korpsmariniers/bergtraining.jpg",
        objectPosition: "bottom",
        content:
          "Het Korps Mariniers is een snel inzetbare eenheid die wereldwijd wordt ingezet voor diverse missies, waaronder gevechtsoperaties, vredeshandhaving, humanitaire hulp en terrorismebestrijding. Mariniers zijn getraind om te opereren in uiteenlopende omgevingen zoals stedelijke gebieden, jungles, bergen en arctische gebieden. Binnen het korps bestaan verschillende specialisaties, zoals:\n\n- Scherpschutter (Sniper): Gespecialiseerd in precisieschieten over lange afstanden.\n- Verbindingsofficier (Communicatiespecialist): Verantwoordelijk voor het opzetten en onderhouden van communicatie tijdens operaties.\n- Medic: Biedt medische ondersteuning in het veld.\n- Mountain Leader: Expert in operaties in bergachtig terrein.\n- Kikvorsman: Gespecialiseerd in onderwateroperaties en duiken.\n\nDeze specialisaties stellen het korps in staat om flexibel en effectief te reageren op uiteenlopende operationele uitdagingen. Daarnaast kunnen mariniers zich, na bewezen inzet, verder ontwikkelen binnen de special forces van het korps, zoals NLMARSOF, of doorgroeien tot mountain leader, kikvorsman of instructeur. Deze opleidingen behoren tot de zwaarste trainingen binnen Defensie.",
      },
      {
        title: "Organisatie & Internationale Partners",
        image: "/img/korpsmariniers/internationalepartners.webp",
        objectPosition: "center",
        content:
          "Het Korps Mariniers is onderdeel van de Koninklijke Marine en heeft zijn hoofdkwartier in Den Helder. Belangrijke bases zijn onder andere de Van Ghentkazerne in Rotterdam en de Marinierskazerne in Doorn. De operationele structuur bestaat uit meerdere eenheden, waaronder:\n\n- Maritime Combat Groups (MCGs): De kerngevechtseenheden van het korps.\n- Sea-based Support Group: Verzorgt logistieke ondersteuning tijdens operaties.\n- Netherlands Maritime Special Operations Forces (NLMARSOF): De special forces eenheid binnen het korps, gespecialiseerd in complexe en geheime operaties.\n\nInternationaal werkt het Korps Mariniers nauw samen met buitenlandse eenheden. Sinds 1972 vormt het samen met de Britse Royal Marines de UK/NL Amphibious Force, een gezamenlijke amfibische strijdmacht binnen NAVO-verband. Daarnaast zijn er samenwerkingen met onder andere het Amerikaanse Marine Corps en andere NAVO-partners, wat de interoperabiliteit en gezamenlijke inzetbaarheid versterkt.",
      },
      {
        title: "Keuring & Selectiemomenten",
        image: "/img/korpsmariniers/fysiekeeisen.jpg",
        objectPosition: "center",
        content:
          "De functiegebonden aanstellingskeuring, de aanvullende Fitheidstest Mariniers en de Kennismakingsdagen Mariniers zijn afzonderlijke beoordelingen. Het halen van één onderdeel betekent niet dat het hele traject is afgerond. Raadpleeg de officiële unitpagina, je vacature en je uitnodiging voor de actuele procedure.",

      },
      {
        title: "Aanvullende Fitheidstest Mariniers",
        image: "/img/korpsmariniers/selectie.jpg",
        objectPosition: "top",
        content: getOfficialStandardText("mariniers"),

      },
      {
        title: "Opleiding & Voorbereiding",
        image: "/img/korpsmariniers/opleidingbarret.jpg",
        objectPosition: "center",
        content: "Voor je voorbereiding kun je werken aan duurvermogen, kracht, zwemvaardigheid, herstel en samenwerken. Dit zijn trainingsgebieden, geen aanvullende lijst met officiële toelatingseisen.\n\nZwemvaardigheid en watervertrouwen kunnen onderdeel zijn van je voorbereiding. Een afstand, kledingvoorschrift of tijdslimiet geldt alleen als Defensie die voor jouw testmoment bevestigt. De vier onderdelen van de aanvullende Fitheidstest staan afzonderlijk op deze pagina.\n\nVoor actuele opleidingsnamen, duur, locaties en instroomroutes zijn de officiële vacature en opleidingsinformatie van Defensie leidend.",

      },
      {
        title: "Carrièrepad & Doorstroom",
        image: "/img/korpsmariniers/specialisaties.jpg",
        objectPosition: "center",
        content: `Na het behalen van je groene baret start je als marinier der tweede klasse. Binnen het korps bestaan verschillende groeipaden, afhankelijk van inzet, prestaties en persoonlijke ambitie.

  Doorgroeimogelijkheden:
  - Gespecialiseerd marinier: Na verloop van tijd kun je je specialiseren als:
    - Sniper (scherpschutter)
    - Medic (gevechtsverpleger)
    - Verbindelaar (ICT/communicatie)
    - Gevechtsinstructeur
    - NLMARSOF (Netherlands Maritime Special Operation Forces)

  - Leidinggevende rollen: Je kunt doorgroeien naar:
    - Groepscommandant
    - Instructeur bij de opleiding
    - Pelotonssergeant via de Korporaalsopleiding, waarin leidinggeven centraal staat

  - Officier worden: Een officiersroute vraagt een eigen voorbereiding op leiderschap, verantwoordelijkheid en fysieke belasting. Controleer de actuele vacature voor opleidingseisen en de instroomroute die bij jouw achtergrond hoort.

  - Special Forces: Ervaren mariniers kunnen solliciteren bij NLMARSOF, de special forces-eenheid van het korps. Deze voert geheime operaties, antiterrorismemissies en complexe interventies uit, vaak onder extreme omstandigheden.

  Doorstroom buiten het korps:
  Ervaren mariniers kunnen zich later ook ontwikkelen binnen:
  - Korps Commandotroepen (KCT)
  - Internationale eenheden via uitwisseling
  - Politie (AT/DSI), brandweer of speciale diensten

  Langetermijncarrière:
  Binnen het Korps Mariniers kun je je blijven ontwikkelen op gebied van logistiek, planning, training, leiderschap of internationale samenwerking. Wie zich blijft bewijzen, blijft groeien.`,
      },
    ],
  },
  contentBlocks: [
    {
      heading: "Special Forces binnen het Korps Mariniers",
      items: [
        {
          title: "Wat is NLMARSOF?",
          content:
            "De Netherlands Maritime Special Operations Forces (NLMARSOF) is de special forces-eenheid binnen het Korps Mariniers. Deze eenheid voert wereldwijd geheime, hoogrisico-operaties uit. Denk aan antiterreuracties, bevrijdingsmissies en verkenningen onder extreme omstandigheden. NLMARSOF werkt vaak samen met internationale special forces en valt onder de hoogste paraatheid binnen Defensie.",
        },
        {
          title: "Mountain Leader",
          content:
            "De Mountain Leader is een marinier die gespecialiseerd is in operaties in bergachtig terrein. Klimmen, abseilen en bewegen in sneeuw, kou en op hoogte geven context aan dit specialisatiegebied. Dit is geen beschrijving van de actuele toelatingsprocedure of een aanvullende fysieke testnorm.",
        },
        {
          title: "Kikvorsman (Combat Diver)",
          content:
            "De kikvorsman is gespecialiseerd in onderwateroperaties, verplaatsing over water en duiken met gesloten systemen. Door het gebruik van speciale apparatuur kunnen zij onder water opereren zonder detecteerbare luchtbellen. De opleiding tot kikvorsman is zwaar: fysiek, technisch én mentaal. Ze voeren operaties uit in kustgebieden, havens, en rivieromgevingen, vaak ongezien en diep achter de linies.",
        },
      ],
    },
    {
      heading: "Voorbereiding op een officiersroute",
      items: [
        {
          title: "Een officiersroute verkennen",
          content:
            "Voor officiersfuncties gelden functiegebonden instroomeisen. Raadpleeg de actuele vacature voor de opleidingsnaam, toelatingsvoorwaarden, duur en locaties; een eerdere beschrijving van een opleidingsroute is daarvoor geen vervanging.",
        },
        {
          title: "Waarop kun je je voorbereiden?",
          content:
            "Als trainingscontext kun je denken aan duidelijke communicatie, samenwerken, verantwoordelijkheid nemen en beslissingen evalueren. Daarnaast bouw je aan kracht, conditie en herstel. Dit zijn voorbereidingsgebieden, geen officiële selectieopdrachten of beoordelingsnormen.",
        },
        {
          title: "Voor wie is dit geschikt?",
          content:
            "De passende instroomroute hangt af van je achtergrond en de functie waarop je solliciteert. Gebruik de actuele vacature om te bepalen welke vooropleiding en selectieonderdelen gelden. Mission Movement kan helpen met je trainingsopbouw, maar beoordeelt geen officiële geschiktheid.",
        },
      ],
    },
  ],
  cta: {
    eyebrow: "Gerichte voorbereiding",
    heading: "Wil je serieus richting het Korps Mariniers?",
    body:
      "Iedere richting vraagt een andere combinatie van kracht, conditie, belastbaarheid, herstel en mentale weerbaarheid. Daarom werk je binnen Mission Movement vanuit een vaste 12-weekse structuur, met accenten die passen bij jouw doel. Je traint niet alleen voor de test. Je bouwt aan het lichaam dat de opleiding en het werk daarna moet kunnen dragen.",
    buttonText: "Bekijk het 12-weekse programma",
    buttonTo: "/program",
  },
  forWho: {
    heading: "Voor wie is dit geschikt?",
    bullets: [
      "Je wilt marinier worden en zoekt structuur in je fysieke en mentale voorbereiding.",
      "Je traint al, maar weet niet zeker of je voorbereiding aansluit op de eisen van keuring en opleiding.",
      "Je wilt sterker worden in kracht, conditie, zwemvaardigheid en belastbaarheid.",
      "Je wilt niet alleen de minimale norm halen, maar met meer marge aan je traject beginnen.",
      "Je zoekt een duidelijke opbouw waarin elke training een functie heeft binnen de grotere voorbereiding.",
      "Je wilt serieus werken aan discipline, herstel, techniek en mentale weerbaarheid.",
    ],
  },
  route: {
    heading: "Jouw route naar het Korps Mariniers",
    steps: [
      "Oriëntatie: begrijpen wat het Korps Mariniers vraagt",
      "Start voorbereiding: kracht, conditie, zwemmen en belastbaarheid opbouwen",
      "Aanmelding en selectieprocedure bij Defensie",
      "Medische keuring, psychologisch onderzoek en fysieke testmomenten",
      "Start opleiding tot marinier",
      "Doorgroeien naar inzetbaarheid, specialisaties en operationeel functioneren",
    ],
  },
  faq: {
    heading: "Veelgestelde Vragen",
    items: [
      {
        title: "Wat zijn de officiële eisen van de Fitheidstest Mariniers?",
        content: getOfficialStandardText("mariniers"),
      },
      {
        title: "Moet ik al superfit zijn voor ik begin met de keuring?",
        content:
          "Nee. Je hoeft geen topatleet te zijn om te starten, maar je moet wel gericht gaan bouwen. Voorbereiding op het Korps Mariniers vraagt om kracht, conditie, zwemvaardigheid, belastbaarheid en mentale weerbaarheid. Mission Movement helpt je gestructureerd trainen, zodat je beter voorbereid richting keuring en opleiding werkt. Je moet consistent kunnen trainen, eerlijk kunnen schalen en pijnsignalen serieus nemen.",
      },
      {
        title: "Kan ik dit combineren met school of werk?",
        content:
          "Ja. Het programma is gemaakt voor kandidaten met een normale agenda naast hun voorbereiding. Je traint met structuur en duidelijke prioriteiten, zodat kracht, conditie, herstel en consistentie uitvoerbaar blijven naast school, werk of andere verplichtingen.",
      },
      {
        title: "Wat als ik nog twijfel over mijn keuze?",
        content:
          "Twijfel is normaal. Gerichte voorbereiding helpt je beter begrijpen wat marinier worden vraagt: fysieke eisen, discipline, mentale druk, herstel en langdurige belasting. Je ontdekt waar je nu staat en wat je nog moet ontwikkelen voordat je richting selectie of opleiding gaat. Bij terugkerende pijn, eerdere zware blessures of twijfel over je belastbaarheid is persoonlijk advies verstandiger dan zelfstandig doortrainen.",
      },
      {
        title: "Wat als ik al zelf train, wat voegt dit toe?",
        content:
          "Zelf trainen is waardevol. Mission Movement brengt structuur aan in kracht, conditie, zwemmen, techniek, herstel en belastbaarheid, zodat je training beter aansluit op selectie, keuring en opleiding.",
      },
      {
        title: "Wat gebeurt er als ik uitval of een week mis?",
        content:
          "Een gemiste week of terugval hoeft je voorbereiding niet te breken. Het programma helpt je herpakken met duidelijke keuzes, aangepaste opbouw en aandacht voor herstel. Het doel is niet perfect trainen, maar duurzaam blijven bouwen aan niveau en belastbaarheid.",
      },
      {
        title: "Is dit programma alleen voor mensen die marinier willen worden?",
        content:
          "De informatie op deze pagina richt zich specifiek op het Korps Mariniers. Het programma kan ook relevant zijn voor kandidaten richting andere Defensie-eenheden, zoals het Korps Commandotroepen of 11 Luchtmobiele Brigade, maar de accenten verschillen per doel. Daarom blijft jouw route en startniveau belangrijk.",
      },
      {
        title: "Is dit programma ook geschikt voor vrouwen?",
        content:
          "Ja. De voorbereiding draait om jouw doel, startniveau en belastbaarheid. Iedereen die serieus richting Defensie of het Korps Mariniers wil werken, heeft baat bij een duidelijke opbouw in kracht, conditie, techniek, herstel en mentale weerbaarheid. De eisen blijven hoog, maar voorbereiding begint met eerlijk kijken waar je nu staat.",
      },
    ],
  },
  stickyMobileCta: {
    enabled: true,
    delayMs: 20000,
    label: "Klaar om gericht te trainen?",
    buttonText: "Bekijk het 12-weekse programma",
    buttonTo: "/program",
  },
};

export default mariniersConfig;
